import {
  isActionFailure,
  isActionSuccess,
} from '~/lib/react-router/action-result';

/** What a waitlist post came back as, in the tracking plan's vocabulary. */
export type WaitlistSubmitOutcome = 'accepted' | 'invalid_email' | 'error';

type FetcherState = 'idle' | 'loading' | 'submitting';

/**
 * Anything that is not a recognisable `join-waitlist` answer reads as `error`:
 * the form's fetcher only ever posts that intent, so the one way it settles
 * without such an answer is the action throwing.
 */
export function waitlistSubmitOutcome(
  fetcherData: unknown
): WaitlistSubmitOutcome {
  if (isActionSuccess(fetcherData) && fetcherData.intent === 'join-waitlist') {
    return 'accepted';
  }
  if (
    isActionFailure(fetcherData) &&
    fetcherData.intent === 'join-waitlist' &&
    fetcherData.error === 'invalid-email'
  ) {
    return 'invalid_email';
  }
  return 'error';
}

/**
 * Reports a post's outcome exactly once: on the render where the fetcher comes
 * back to idle. `fetcher.data` stays set after that, so keying off the data
 * alone would report the same post again on every re-render and revalidation.
 */
export function createSubmitSettleDetector() {
  let inFlight = false;
  return function observe(
    state: FetcherState,
    data: unknown
  ): WaitlistSubmitOutcome | null {
    if (state !== 'idle') {
      inFlight = true;
      return null;
    }
    if (!inFlight) return null;
    inFlight = false;
    return waitlistSubmitOutcome(data);
  };
}
